module.exports = __webpack_public_path__ + "img/rockstaripphonerender1_00073.618b6f7.png";